var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.value ? _c('div', {
    staticClass: "demo-upload-list"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }), _c('div', {
    staticClass: "demo-upload-list-cover"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-eye-outline"
    },
    on: {
      "click": _vm.handleView
    }
  }), _c('Icon', {
    attrs: {
      "type": "ios-trash-outline"
    },
    on: {
      "click": _vm.handleRemove
    }
  })], 1)]) : _c('Upload', {
    ref: "upload",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "drag": true,
      "name": "files",
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.handleSuccess,
      "show-upload-list": false,
      "action": "/api/file/upload",
      "format": ['jpg', 'jpeg', 'png'],
      "accept": '.jpg,.jpeg,.png',
      "headers": _vm.headers,
      "max-size": 10485760,
      "multiple": "",
      "type": "drag"
    }
  }, [_c('div', {
    staticClass: "plus"
  }, [_c('Icon', {
    attrs: {
      "type": "md-add",
      "size": "20"
    }
  })], 1)]), _c('Modal', {
    attrs: {
      "title": $t("bgh7yl4", "图片预览"),
      "footer-hide": "",
      "mask-closable": false
    },
    model: {
      value: _vm.preview,
      callback: function ($$v) {
        _vm.preview = $$v;
      },
      expression: "preview"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };